import { useMediaQuery } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useSpring } from '@react-spring/core';
import { animated } from '@react-spring/web';
import Drawer from 'components/Drawer';
import { MODULES } from 'config/constants/modules';
import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import BuyHunnyButton from './BuyHunnyButton';

const Navigation: React.FC = ({ children }) => {
	const [open, setOpen] = useState(false);
	const history = useHistory();

	const openDrawer = useCallback(() => setOpen(true), []);
	const closeDrawer = useCallback(() => setOpen(false), []);

	const handleClickSelect = useCallback(() => {
		if (open) {
		} else {
			setOpen(true);
		}
	}, [open]);

	const handleNavigate = useCallback((path: string) => {
		setOpen(false);
		history.push(path);
	}, []);

	return (
		<StyleWrapLayout>
			<StyledContent
				onClick={() => {
					handleClickSelect();
				}}
			>
				{children}
			</StyledContent>

			<StyledDrawer anchor={'left'} onOpen={openDrawer} onClose={closeDrawer} open={open}>
				<StyledWrapContent>
					<StyledWrapIconBack onClick={closeDrawer}>
						<ArrowBackIcon style={{ marginRight: 4 }} />
						Back
					</StyledWrapIconBack>
					<StyleWrapContainerOption>
						<StyledLWrapLink onClick={() => handleNavigate(MODULES.HOME)}>
							<StyleWrapItemOption>
								<StyledPageOption>Home</StyledPageOption>
							</StyleWrapItemOption>
						</StyledLWrapLink>

						<StyledLWrapLink onClick={() => handleNavigate(MODULES.MARKETPLACE)}>
							<StyleWrapItemOption>
								<StyledPageOption>Marketplace</StyledPageOption>
							</StyleWrapItemOption>
						</StyledLWrapLink>

						<StyledLWrapLink onClick={() => handleNavigate(MODULES.MYSTERY_BOXES)}>
							<StyleWrapItemOption>
								<StyledPageOption>Mystery Boxes</StyledPageOption>
							</StyleWrapItemOption>
						</StyledLWrapLink>

						<StyledLWrapLink onClick={() => handleNavigate(MODULES.STAKING)}>
							<StyleWrapItemOption>
								<StyledPageOption>NFT Staking</StyledPageOption>
							</StyleWrapItemOption>
						</StyledLWrapLink>
						<StyledRedirectPancakeHunny href="https://pancakehunny.finance/">
							<StyleWrapItemOption>
								<StyledPageOption>Farm</StyledPageOption>
							</StyleWrapItemOption>
						</StyledRedirectPancakeHunny>
					</StyleWrapContainerOption>

					<StyledBuyHunnyButton>
						<BuyHunnyButton includeIcon />
					</StyledBuyHunnyButton>
				</StyledWrapContent>
			</StyledDrawer>
		</StyleWrapLayout>
	);
};

const StyledDrawer = styled(Drawer)`
	& .MuiBackdrop-root {
		top: 0;
		background-color: transparent;
	}

	& .MuiPaper-root {
		top: 0 !important;
		background-color: transparent;

		@media (max-width: 580px) {
			margin-top: 0 !important;
		}
	}
`;

const StyledBuyHunnyButton = styled.div`
	float: left;
`;

const StyledWrapContent = styled.div`
	padding-left: 15px;
	padding-top: 25px;
	width: 50vw;
	height: 100vh;
	background: rgba(0, 0, 0, 0.6);
	backdrop-filter: blur(10px);
`;

const StyledWrapIconBack = styled.button`
	display: flex;
	align-items: center;
	color: ${(props) => props.theme.color.grey[600]};
	padding: 24px 0;
	font-size: 16px;
	border: none;
	cursor: pointer;
	background: none;
	height: auto;
	font-weight: bold;
`;

const StyleWrapLayout = styled.div`
	padding: 12px 12px 12px 0;
	box-sizing: border-box;
	border-radius: 8px;

	@media (min-width: 925px) {
		display: none;
	}
`;
const StyledLWrapLink = styled.div``;
const StyledRedirectPancakeHunny = styled.a`
	background-color: transparent;
`;

const StyledContent = styled.div``;

const StyleWrapContainerOption = styled(animated.div)`
	display: flex;
	flex-direction: column;
	padding: 10px;
	box-sizing: border-box;

	a {
		text-decoration: none;
		border-bottom: 0;
	}
`;

const StyleWrapItemOption = styled.div`
	display: flex;
	align-items: center;
	padding: 14px 0;
	border-radius: 4px;
	cursor: pointer;
	min-width: 128px;

	/* &:hover {
		background-color: #212947;
	} */
`;

const StyledPageOption = styled.div`
	color: white;
	font-weight: bold;
	font-size: 14px;
	line-height: 15px;
	font-family: 'ubuntu';
	margin-left: 4px;
	text-decoration: none;
	border-bottom: none;

	&::after {
		border-bottom: none;
		text-decoration: none;
	}
	&.header {
		margin-left: 8px;
	}
`;

export default Navigation;
